import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IconButton from "../../common/IconButton";
import { FaEdit } from "react-icons/fa";

function MyProfile(props) {
  const { user } = useSelector((state) => state.profile);
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div>
        <h1 className="text-richblack-25 text-3xl">My Profile</h1>
      </div>

      {/* section 1 */}
      <div className="bg-richblack-800 w-full py-5 px-4 rounded-md mt-10 gap-x-10 text-richblack-50 flex justify-between relative items-center">
        <div className="flex items-center gap-x-5 max-[450px]:gap-x-4">
          <img
            src={`${user?.image}`}
            alt={`profile-${user.firstName}`}
            className="aspect-square w-[78px] rounded-full object-cover max-[450px]:w-[40px]"
          />
          <div>
            <p>{user?.firstName + " " + user?.lastName}</p>
            <p className="text-richblack-100 max-[450px]:text-[15px]">
              {user?.email}
            </p>
          </div>
        </div>
        <button
          className="flex items-center gap-x-2 px-4 py-2 w-fit h-10 bg-yellow-50 text-richblack-900 rounded-md absolute right-10 max-[450px]:right-2"
          onClick={() => {
            navigate("/dashboard/settings");
          }}>
          Edit
          <FaEdit />
        </button>
        {/* <IconButton
          text={"Edit"}
          
        /> */}
      </div>

      {/* section 2 */}
      <div className="bg-richblack-800 w-full py-5 px-4 rounded-md mt-10 gap-x-10 text-richblack-50 flex justify-between relative items-center">
        <div>
          <p className="text-richblack-25 text-2xl">About</p>
          <p className="text-richblack-100 mt-2">
            {user?.additionalDetails?.about ? (
              user?.additionalDetails?.about
            ) : (
              <span>Write something about your self</span>
            )}
          </p>
        </div>
        <button
          className="flex items-center gap-x-2 px-4 py-2 w-fit h-10 bg-yellow-50 text-richblack-900 rounded-md absolute right-10 max-[450px]:right-2"
          onClick={() => {
            navigate("/dashboard/settings");
          }}>
          Edit
          <FaEdit />
        </button>
      </div>

      {/* section 3 */}
      <div className="bg-richblack-800 w-full py-5 px-4 rounded-md mt-10 gap-x-10 text-richblack-50 flex justify-between relative items-center">
        <div className="cursor-pointer">
          <p className="text-2xl mb-5">Personal Details</p>
          <div className="grid grid-cols-2 max-[450px]:grid-cols-1 gap-5 gap-x-32">
            <div className="flex flex-col gap-y-1">
              <p className="text-richblack-100 text-md hover:text-richblack-200 transition-all duration-200">
                First Name
              </p>
              <p className="text-richblack-50 text-lg hover:text-richblack-25 transition-all duration-200">
                {user?.firstName}
              </p>
            </div>
            <div className="flex flex-col gap-y-1">
              <p className="text-richblack-100 text-md hover:text-richblack-200 transition-all duration-200">
                Last Name
              </p>
              <p className="text-richblack-50 text-lg hover:text-richblack-25 transition-all duration-200">
                {user?.lastName}
              </p>
            </div>
            <div className="flex flex-col gap-y-1">
              <p className="text-richblack-100 text-md hover:text-richblack-200 transition-all duration-200">
                Email
              </p>
              <p className="text-richblack-50 text-lg hover:text-richblack-25 transition-all duration-200">
                {user?.email}
              </p>
            </div>

            <div className="flex flex-col gap-y-1">
              <p className="text-richblack-100 text-md hover:text-richblack-200 transition-all duration-200">
                Phone Number
              </p>
              <p className="text-richblack-50 text-lg hover:text-richblack-25 transition-all duration-200">
                {user?.additionalDetails.contactNumber ?? "Add contact number"}
              </p>
            </div>

            <div className="flex flex-col gap-y-1">
              <p className="text-richblack-100 text-md hover:text-richblack-200 transition-all duration-200">
                Gender
              </p>
              <p className="text-richblack-50 text-lg hover:text-richblack-25 transition-all duration-200">
                {user?.additionalDetails?.gender ?? "Add gender"}
              </p>
            </div>

            <div className="flex flex-col gap-y-1">
              <p className="text-richblack-100 text-md">Date of Birth</p>
              <p className="text-richblack-50 text-lg hover:text-richblack-25 transition-all duration-200">
                {user?.additionalDetails.dateOfBirth ?? "Add date of birth"}
              </p>
            </div>
          </div>
        </div>

        <button
          className="flex items-center gap-x-2 px-4 py-2 w-fit h-10 bg-yellow-50 text-richblack-900 rounded-md absolute right-10 max-[450px]:right-2"
          onClick={() => {
            navigate("/dashboard/settings");
          }}>
          Edit
          <FaEdit />
        </button>
      </div>
    </div>
  );
}

export default MyProfile;